import { EventEmitter, Input, Output } from '@angular/core';
import { ClientModel } from '../../../../../shared/models/client.model';
import { PaymentMethodModel } from '../../../../../shared/models/payment-method.model';
import { SubscriptionModel } from '../../../../../shared/models/payment/subscription/subscription.model';

export abstract class AccountSubscriptionsDetailsActionsPaymentMethod {
    @Output('choosen') choosen: EventEmitter<any> = new EventEmitter<any>();
    @Input('client') client: ClientModel;
    @Input('paymentMethod') paymentMethod: PaymentMethodModel;
    @Input('subscription') subscription: SubscriptionModel;

    public choose(
        paymentMethodId: number,
        installments: number = null,
        paymentCardId: number = null
    ) {
        const data = {
            installment: {
                financial_entries: []
            }
        };

        this.subscription.financial_entries.forEach(financialEntry => {
            data.installment.financial_entries.push({
                'id': financialEntry.id,
                'payment_method_id': paymentMethodId
            });
        });

        if (null !== paymentCardId && null !== installments) {
            data['offer_payment_card'] = {
                installments: installments,
                payment_card_id: paymentCardId
            };
        }

        this.choosen.emit(data);
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3894461559/src/src/app/account/subscriptions/details/actions/payment-method/account.subscriptions.details.actions.payment-method.ts